<template>
    <div class="extras__info">

        <!-- When the list is not being duplicated -->
        <div class="people" v-if="!parentList">
            <div class="lock-icon" v-if="list.secret">
                <svg class="lock"><use xlink:href="#lock"></use></svg>
            </div>
            <img :src="list.user.large_profile">
        </div>

        <h3 v-if="!parentList">
            <span>Created</span> by
            <a :href="`/${list.user.username}`" class="person-hover-trigger" :data-user="list.user.username" v-text="list.user.full_name"></a>
            <br>
            Updated {{ diffForHumans(list.updated_at) }}
        </h3>

        <!-- If the list has been duplicated -->
        <div class="people duplicated" v-if="parentList">
            <div class="lock-icon" v-if="list.secret">
                <svg class="lock"><use xlink:href="#lock"></use></svg>
            </div>
            <img :src="parentList.user.profile_thumbnail">
            <div class="duplicated">
                <img :src="list.user.profile_thumbnail">
            </div>
        </div>

        <h3 v-if="parentList" style="margin-left: 10px">
            <span>Originally Created</span> by
            <a :href="`/${parentList.user.username}`" class="person-hover-trigger" :data-user="parentList.user.username" v-text="parentList.user.full_name"></a>
            <br>
            <div class="normal-text">{{ duplicatedByText }}</div>
        </h3>

    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers'
export default {

    mixins:[Helpers],

    props:['list'],

    data(){
        return {
            parentList : this.list.original_list,
        }
    },

    computed:{
        duplicatedByText(){
            let when = this.diffForHumans(this.list.updated_at)
            let who = (config.user && (this.list.user.id == config.user.id)) ? 'you' : this.list.user.full_name
            return `Updated by ${who} ${when}`
        }
    }
}
</script>
